import cartService from '../services/cart.service';

export const getCart=()=>(dispatch)=>{
    dispatch({type : 'CART_REQUEST'})
    cartService.getCart()
                  .then((res)=>{
                    dispatch({
                        type : 'CART_SUCCESS',
                        payload : res.data
                    })
                  })
                  .catch((error)=>{
                    dispatch({
                        type : 'CART_FAILED',
                        payload : error?.response?.statusText
                    })
                  })
};

export const getWishlistCartDetails=(variationId)=>(dispatch)=>{
    dispatch({type : 'CART_WISHLIST_DETAIL_REQUEST'})
    cartService.getWishlistCartDetails(variationId)
                  .then((res)=>{
                    dispatch({
                        type : 'CART_WISHLIST_DETAIL_SUCCESS',
                        payload : res.data
                    })
                  })
                  .catch((error)=>{
                    dispatch({
                        type : 'CART_WISHLIST_DETAIL_FAILED',
                        payload : error?.response?.statusText
                    })
                  })
};

//add to cart
export const addToCart = (data) => (dispatch) => {
    dispatch({type : 'ADD_TO_CART_REQUEST'})
    cartService.addToCart(data)
        .then((res) => {
            if (res.data) {
                dispatch({
                    type : 'ADD_TO_CART_SUCCESS',
                    payload : res.data
                })
                dispatch(getCart())
            } else {
                dispatch({
                    type : 'ADD_TO_CART_FAILED',
                    payload : 'Failed to add item to cart'
                })
            }
        })
        .catch((error) => {
            console.error('Add to cart error:', error);
            dispatch({
                type : 'ADD_TO_CART_FAILED',
                payload : error?.response?.data?.message || 'Failed to add item to cart'
            })
        })
};